import * as amplitude from '@amplitude/analytics-browser';

const init = (apiKey: string) => {
  if (apiKey) {
    amplitude.init(apiKey, {
      autocapture: {
        attribution: false,
        sessions: true, // this would satisfy session_duration
        formInteractions: false,
        fileDownloads: false,
        elementInteractions: false,
        pageViews: true, // this would satisfy: workout_viewed, and navigation_clicked
      },
    });
  }
  return amplitude;
};
const identifyEvent = new amplitude.Identify();
amplitude.identify(identifyEvent);

export { init, amplitude, identifyEvent };
